import gql from 'graphql-tag';
import ContentFields from '../fragments/content';

export default gql`
  query searchRegularContent(
    $keywords: String!
    $limit: Int
  ) {
    searchRegularContent(
      keywords: $keywords
      limit: $limit
    ) {
      ...ContentFields
    }
  }
  ${ContentFields}
`;
